<template>
  <div class="scard biddinglistsome" @click="goDetail(item)">
    <div class="biddinglistsomeimg">
      <img :src="item.imageUrl" alt="" style="height: 150px; width: 255px" />
      <div class="time">
        距竞价结束:
        <MyCountDown
          type="biding"
          @finished="getList"
          :startTime="item.systemDate"
          :endTime="item.bidEndTime"
        ></MyCountDown>
      </div>
      <img
        :src="item.disposalCode === '1' ? tagImg : tagImg2"
        alt=""
        class="biddinglistsomeimgclass"
      />
    </div>
    <div class="biddinglistsomeintru">
      <div class="minh80">
        <p class="biddinglistsomeintrutitle">
          {{ item.title }}
        </p>
        <p class="text">公告编号 : {{ item.code }}</p>
        <template v-if="item.disposalCode === '1' || item.bidCodeMate === '10'">
          <p class="textprice" v-if="item.disposalCode === '1'">
            当前价 :
            <span class="price">{{
              item.maxQuotePrice ? item.maxQuotePrice : item.startPrice
            }}</span
            ><span v-if="item.bidCode !== '10'">
              {{ item.unitName ? `元/${item.unitName}` : '元' }}</span
            >
            <span v-else>元</span>
          </p>
          <p class="text textcolor">
            开盘价 : <span class="textcolor1">{{ item.startPrice }}</span
            ><span class="textcolor1" v-if="item.bidCode !== '10'">
              {{ item.unitName ? `元/${item.unitName}` : '元' }}</span
            >
            <span class="textcolor1" v-else>元</span>
          </p>
        </template>
        <p class="text textcolor" v-if="item.disposalCode === '1'">
          出价次数 :
          <span class="textcolor1">{{ item.countQuotePrice }}</span>
        </p>
        <template v-if="item.disposalCode === '2' && item.bidCodeMate === '05'">
          <p class="fenx">多物资分项报价，请查看详情</p>
        </template>
      </div>

      <div class="location">
        <p>
          <img
            src="../../../assets/imgs/Vector2.png"
            alt=""
            style="margin-right: 4px; height: 14px; width: 11.8px"
          />
          <span class="locationsome">{{ item.proviceName }}</span>
        </p>
        <p>
          <span class="locationsome"
            >围观次数 :
            <span class="textcolor1">{{ item.readTimes }}</span></span
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinCard } from '@/utils/mixinCard.js'
export default {
  name: 'scard',
  mixins: [mixinCard],
  data() {
    return {
      strDate: '',
      tagImg: require('@/assets/imgs/gkjj.png'),
      tagImg2: require('@/assets/imgs/mfbj.png')
    }
  },
  created() {
    this.currentTime()
  },
  methods: {
    /**
     * 获取当前时间
     */
    currentTime() {
      var date = new Date()
      var year = date.getFullYear() //月份从0~11，所以加一
      // let month = date.getMonth()
      // console.log('month', month)
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      ]
      //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = '0' + dateArr[i]
        }
      }
      var strDate =
        year +
        '-' +
        dateArr[0] +
        '-' +
        dateArr[1] +
        ' ' +
        dateArr[2] +
        ':' +
        dateArr[3] +
        ':' +
        dateArr[4]
      this.strDate = strDate
    }
  }
}
</script>

<style lang="less" scoped>
.biddinglistsome {
  cursor: pointer;
  height: 365px;
  // width: 275px;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  margin-left: 20px;
  margin-top: 20px;
  margin-bottom: 20px;

  .biddinglistsomeimg {
    height: 160px;
    padding: 10px 10px 0 10px;
    position: relative;

    .time {
      height: 30px;
      background: #333333;
      opacity: 0.8;
      font-family: 'Source Han Sans CN';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 30px;
      /* identical to box height, or 100% */
      margin-top: -30px;
      text-align: center;

      /* 灰色/文字/W0-#FFFFFF */

      color: #ffffff;
      .count-downnew {
        color: #ffffff;
      }
    }

    .biddinglistsomeimgclass {
      position: absolute;
      top: 20px;
      left: -1px;
      height: 30px;
    }
  }

  .biddinglistsomeintru {
    width: 275px;
    height: 205px;
    padding: 10px;

    .biddinglistsomeintrutitle {
      font-family: 'Source Han Sans CN';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;

      color: #333333;
      width: 200px;
      display: block;
      width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 5px;
    }

    .text {
      font-family: 'Source Han Sans CN';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #333333;
    }

    .textcolor {
      color: #666666;
    }

    .textcolor1 {
      color: #333333;
      font-family: 'Source Han Sans CN';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      /* identical to box height, or 100% */

      /* 灰色/文字/Gy8-#333333 */

      color: #333333;
    }

    .location {
      height: 36px;
      border-top: 1px solid #dcdcdc;
      margin-top: 15px;
      display: flex;
      align-items: center;
      justify-items: center;
      align-items: center;
      justify-content: space-between;
      position: relative;

      .locationsome {
        font-family: 'Source Han Sans CN';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 12px;
        /* identical to box height, or 100% */

        /* 灰色/文字/Gy7-#666666 */

        color: #666666;
        vertical-align: middle;
      }
    }

    .textprice {
      font-family: 'Source Han Sans CN';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 50px;
      /* identical to box height, or 100% */

      /* 灰色/文字/Gy7-#666666 */

      color: #666666;

      .price {
        font-family: 'Source Han Sans CN';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 20px;
        /* identical to box height, or 100% */

        /* 红色/功能色/R3-#F0250F */

        color: #f0250f;
      }
    }
  }
}
.fenx {
  color: #2587ff;
  font-size: 16px;
  font-weight: 500;
  line-height: 95px;
}
.minh80 {
  min-height: 140px;
}
</style>
